import script from "./EntryAuth.vue?vue&type=script&setup=true&lang=ts"
export * from "./EntryAuth.vue?vue&type=script&setup=true&lang=ts"

import "./EntryAuth.vue?vue&type=style&index=0&id=48643895&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48643895"]])

export default __exports__